export const AUTH_SESSION_QUERY_PREFIX = 'session' as const;
export const AuthQueryKeys = { session: () => [ AUTH_SESSION_QUERY_PREFIX ] as const };
